import PropTypes from "prop-types";
import responseHandler from "responseHandler";
import {connect} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {Box} from "@mui/material";
import {watchGroupDelete} from "requests/watches";
import {EmptyCard} from "components/Shared/EmptyCard";
import {MCard} from "components/Shared";
import MSpinner from "components/Shared/MSpinner.tsx";

const watchGroupDeleteStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  margin: '100px',
};

const WatchGroupDelete = ({ match: { params }}) => {
  const watchGroupId = params.watchGroupId;
  const [wasSuccessful, setWasSuccessful] = useState(false);
  const mounted = useRef(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    watchGroupDelete(watchGroupId, unsubscribeResponse, mounted);
  }, [watchGroupId]);

  const unsubscribeResponse = () => {
    setWasSuccessful(true);
    setIsLoading(false);
  };

  if (isLoading) return <MSpinner />;

  if (wasSuccessful) {
    return (
        <Box sx={watchGroupDeleteStyles}>
          <MCard title="Unsubscribe Case Events: Successful">
            <EmptyCard message="You have successfully unsubscribed from these cases events" />
          </MCard>
        </Box>);
  }
  else{
    return (
        <Box sx={watchGroupDeleteStyles}>
          <MCard title="Unsubscribe Case Events: Failed">
            <EmptyCard message="An error has occurred and was unable to unsubscribe" />
          </MCard>
        </Box>);
  }
};

WatchGroupDelete.propTypes = {
  match: PropTypes.object.isRequired,
  makeToast: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  makeToast: text => {
    responseHandler.customToast(text, "error", dispatch);
  }
});

export default connect(null, mapDispatchToProps)(WatchGroupDelete);
